module.exports = __webpack_public_path__ + "img/task-2.29df6b15.png";